import { useEffect, useRef } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot, BLUR_COMMAND, COMMAND_PRIORITY_LOW } from 'lexical';

export function UpdateHandler({ onChange, onBlur, qwantumId }) {
  const [editor] = useLexicalComposerContext();
  const lastStateRef = useRef('');
  const lastTextContentRef = useRef('');
  
  const saveContent = (forceUpdate = false) => {
    editor.getEditorState().read(() => {
      const root = $getRoot();
      const textContent = root.getTextContent();
      const lexicalState = JSON.stringify(editor.getEditorState().toJSON());
      
      // Only save if content changed
      if (lexicalState !== lastStateRef.current) {
        lastStateRef.current = lexicalState;
        
        // For qwantumId persistence, only save on blur or text content changes
        if (qwantumId && !forceUpdate) {
          // Check if only styling changed (same text content)
          if (textContent === lastTextContentRef.current) {
            return; // Skip save for style-only changes
          }
        }
        
        lastTextContentRef.current = textContent;
        onChange(textContent, lexicalState);
      }
    });
  };
  
  useEffect(() => {
    // Save on blur - always save
    return editor.registerCommand(
      BLUR_COMMAND,
      () => {
        saveContent(true); // Force save on blur
        if (onBlur) {
          onBlur();
        }
        return false;
      },
      COMMAND_PRIORITY_LOW
    );
  }, [editor, onChange, onBlur]);

  useEffect(() => {
    // Register update listener
    return editor.registerUpdateListener(({ editorState }) => {
      saveContent();
    });
  }, [editor, onChange]);

  return null;
}